import { Carousel } from "./Carousel";

new Carousel().Init();
